import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";

interface Font {
  family: string;
}

interface FontData {
  fontFamily: string;
  fontCDN: string;
}

interface GoogleFontsDropdownProps {
  onSelectFont: (fontData: FontData) => void;
  selectedFontFamily?: string;
}

const GoogleFontsDropdown: React.FC<GoogleFontsDropdownProps> = ({
  onSelectFont,
  selectedFontFamily = "",
}) => {
  const [fonts, setFonts] = useState<Font[]>([]);
  const [selectedFont, setSelectedFont] = useState<string>("");

  useEffect(() => {
    setSelectedFont(selectedFontFamily);
  }, [selectedFontFamily]);

  useEffect(() => {
    const fetchFonts = async () => {
      try {
        const API_KEY = "AIzaSyB2yXMN0saUR2QQnN0DvOJ-Rs_qLRDpQ2M";
        const response = await axios.get(
          `https://www.googleapis.com/webfonts/v1/webfonts?key=${API_KEY}`
        );
        setFonts(response.data.items);
      } catch (error) {
        console.error("Error fetching Google Fonts:", error);
      }
    };

    fetchFonts();
  }, []);

  const handleFontSelect = (event: SelectChangeEvent<string>) => {
    const fontName = event.target.value;
    setSelectedFont(fontName);

    const fontCDN = `https://fonts.googleapis.com/css2?family=${fontName.replace(
      / /g,
      "+"
    )}&display=swap`;

    onSelectFont({ fontFamily: fontName, fontCDN });
  };

  return (
    <div>
      <FormControl fullWidth sx={{ minWidth: 200 }}>
        <Select
          labelId="font-select-label"
          id="fontSelect"
          value={selectedFont}
          onChange={handleFontSelect}
          displayEmpty
        >
          <MenuItem value="">
            <em>Choose a font</em>
          </MenuItem>
          {fonts.map((font) => (
            <MenuItem key={font.family} value={font.family}>
              {font.family}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default GoogleFontsDropdown;
